export const dpConfig = {
  http: {
    api: process.env.API_URL,
  },
  support: process.env.SUPPORT_URL,
  language: {
    fallback: 'en',
  },
  debounce: {
    search: process.env.DEBOUNCE_SEARCH,
  },
  env: process.env.NODE_ENV,
};

export type DPConfig = typeof dpConfig;
